export const conversationalPreviewSettingsWorkflows = "/:app_group_id/conversational/preview_settings/workflows";
